import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import CreateCustomerPage from './pages/CreateCustomerPage';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import MonitorPage from './pages/Monitor/MonitorPage';
import ForgotPasswordPage from './pages/Login/ForgotPasswordPage';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminCreateUserDevice from './pages/Admin/AdminCreateUserDevice';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminDevices from './pages/Admin/AdminDevices';




function App() {
    // مقدار اولیه را مستقیم از localStorage می‌گیریم
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const [isChecking, setIsChecking] = useState(!!localStorage.getItem('token')); // فقط اگر توکن داشتیم لودینگ نشان بده
    
    const navigate = useNavigate();

    useEffect(() => {
        const validateToken = async () => {
            const token = localStorage.getItem('token');
            
            if (!token) {
                setIsAuthenticated(false);
                setIsChecking(false);
                return;
            }

            try {
                // ✅ آدرس را به دامنه اصلی تغییر دادم
                const response = await fetch('https://sfarm.tabangohar.com/api/auth_check.php', {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

                const data = await response.json();

                if (response.ok && data.status === 'success') {
                    setIsAuthenticated(true);
                } else {
                    // اگر توکن منقضی شده بود
                    console.error("Session expired");
                    localStorage.removeItem('token');
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error("Network error:", error);
                // در صورت خطای شبکه، کاربر را بیرون نمی‌اندازیم تا آفلاین کار کند
            } finally {
                setIsChecking(false);
            }
        };

        validateToken();
    }, []);

    const handleLogin = (token) => {
        localStorage.setItem('token', token);
        setIsAuthenticated(true);
       
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        navigate('/login'); 
    };

    // ✅ نمایش لودینگ (مانع از پرش ناگهانی به صفحه لاگین می‌شود)
    if (isChecking) {
        return (
            <div style={{ background: '#0d004c', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontFamily: 'IRANSans' }}>
                در حال تایید هویت...
            </div>
        );
    }
    const getUserRole = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.role;
    } catch {
        return null;
    }
};

const getHomePath = () => {
    return getUserRole() === 'admin' ? '/admin' : '/';
};

    return (
        <Routes>
           <Route 
    path="/login"
    element={!isAuthenticated ? <LoginPage onLogin={handleLogin} /> : <Navigate to={getHomePath()} />}
/>

            <Route 
             path="/forgot-password"
            element={<ForgotPasswordPage />}
            />
            
            <Route 
    path="/"
    element={
        isAuthenticated
            ? (
                getUserRole() === 'admin'
                    ? <Navigate to="/admin" replace />
                    : <DashboardPage onLogout={handleLogout} />
              )
            : <Navigate to="/login" replace />
    }
/>
            <Route
            path="/admin/users"
            element={isAuthenticated ? <AdminUsers /> : <Navigate to="/login" />}
            />

            <Route
                path="/admin"
                element={isAuthenticated ? <AdminDashboard onLogout={handleLogout} /> : <Navigate to="/login" />}
            />
            <Route
              path="/admin/create-user-device"
              element={isAuthenticated ? <AdminCreateUserDevice /> : <Navigate to="/login" />}
            />
            <Route
                path="/admin/devices"
                element={isAuthenticated ? <AdminDevices /> : <Navigate to="/login" />}
            />

            <Route 
                path="/monitor/:id" 
                element={isAuthenticated ? <MonitorPage /> : <Navigate to="/login" />} 
            />
            
            <Route 
                path="/create"
                element={isAuthenticated ? <CreateCustomerPage onLogout={handleLogout} /> : <Navigate to="/login" />}
            />

            {/* مدیریت صفحات ناشناخته */}
            <Route path="*" element={<Navigate to={isAuthenticated ? getHomePath() : "/login"} />} />
        </Routes>
    );
}

export default App;